import React from 'react';
import { CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import { getId } from '../../../../Utils';
import { handleLoginService } from '../../../../Services/handleLocalStorage';
import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import {
    SearchInput,
    FormModalContainer,
    FormModalContent,
    UsersContainer,
    AddViaEmailBlock,
    AddViaEmailButton,
} from './style';
import { Loading } from '../../../Containers/WithLoading/Loading';
import { EmptyState } from '../../../Containers/WithEmptyState/EmptyState';
import { FollowersEmptyState, UsersEmptyState } from '../../BannerEmptyStats/BannerEmptyStats';
import AddMemberRow from '../../Rows/AddMemberRow';
import debounce from 'lodash.debounce';
import InfiniteUsersSearch from './InfiniteUsersSearch';
import AddMemberWithEmailModal from '../AddMemberWithEmailModal';
import { ProfileActionCreators } from '../../../../Store/ActionCreators/ProfileActionCreators';
import { SearchUsersActionCreators } from '../../../../Store/ActionCreators/SearchUsersActionCreators';
import { MembersActionCreators } from '../../../../Store/ActionCreators/MembersActionCreators';

const HeadingText = ({ children }) => (
    <Text opacity={0.5} marginTop={'25px'} marginBottom={'15px'} weight={'bold'} small uppercase>
        {children}
    </Text>
);

const DescriptionText = ({ children }) => (
    <Text alignCenter marginBottom={'15px'} lineHeight={1.33} fontSize={13} weigh={300}>
        {children}
    </Text>
);

// todo: refactor and split into smaller components
class AddmemberModal extends React.Component {
    state = {
        searchFilter: '',
        isViaEmail: false,
    };

    handleInputChange = e => {
        this.setState({ searchFilter: e.target.value }, () => {
            this.searchWithDelay();
        });
    };

    searchWithDelay = debounce(() => {
        this.props.getSearchUsers(this.state.searchFilter);
    }, 250);

    toggleEmail = () => {
        this.setState(prevState => ({
            isViaEmail: !prevState.isViaEmail,
        }));
    };

    render() {
        const { onClose, followersLoading, followers, usersLoading, users, addMember, deleteMember } = this.props;
        const { searchFilter, isViaEmail } = this.state;
        const followersEmpty = followers.length === 0;
        const usersEmpty = users.length === 0;

        return isViaEmail ? (
            <AddMemberWithEmailModal onClose={this.toggleEmail} />
        ) : (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter fontSize={22} weight={'bold'}>
                        Add members
                    </Text>
                    <DescriptionText>
                        New members will receive an email from Tona. Don’t forget to assign credits on members page once
                        added.
                    </DescriptionText>

                    <AddViaEmailBlock>
                        <Text weight={'bold'}>User not on Tona yet?</Text>
                        <AddViaEmailButton onClick={this.toggleEmail}>Add via email</AddViaEmailButton>
                    </AddViaEmailBlock>

                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <div style={{ width: '100%' }}>
                        <SearchInput
                            value={searchFilter}
                            onChange={this.handleInputChange}
                            placeholder={'Search among Tona users'}
                        />
                    </div>

                    <div style={{ width: '100%' }}>
                        <HeadingText>{searchFilter === '' ? 'Your followers' : 'Everyone on Tona'}</HeadingText>
                    </div>

                    {/* refactor in the future */}
                    <UsersContainer id="add-member-modal-scroll">
                        {searchFilter === '' ? (
                            <Loading isLoading={followersLoading}>
                                <EmptyState isEmpty={followersEmpty} emptyState={FollowersEmptyState}>
                                    {followers.map((follower, index) => (
                                        <AddMemberRow
                                            key={index}
                                            onAdd={addMember}
                                            onDelete={deleteMember}
                                            {...follower}
                                        />
                                    ))}
                                </EmptyState>
                            </Loading>
                        ) : (
                            <Loading isLoading={usersLoading}>
                                <EmptyState isEmpty={usersEmpty} emptyState={UsersEmptyState}>
                                    <InfiniteUsersSearch
                                        scrollableTarget={'add-member-modal-scroll'}
                                        filter={searchFilter}
                                    >
                                        {users.map((user, index) => (
                                            <AddMemberRow
                                                key={index}
                                                onAdd={addMember}
                                                onDelete={deleteMember}
                                                {...user}
                                            />
                                        ))}
                                    </InfiniteUsersSearch>
                                </EmptyState>
                            </Loading>
                        )}
                    </UsersContainer>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

const mapStateToProps = ({
    profile: {
        followers,
        statuses: { followersLoading },
    },
    usersSearch: { users, loading },
}) => ({
    followers,
    followersLoading,
    users,
    usersLoading: loading,
});

const mapDispatchToProps = dispatch => ({
    getFollowers() {
        const USER_ID = getId(handleLoginService.getUserId());
        dispatch(ProfileActionCreators.getProfileFollowersRequest(USER_ID));
    },
    addGymMember(data, callback) {
        dispatch(MembersActionCreators.addMemberRequest(data, callback));
    },
    deleteGymMember(id, callback) {
        dispatch(MembersActionCreators.deleteMemberRequest(id, callback));
    },
    getSearchUsers(filter) {
        dispatch(SearchUsersActionCreators.getUsers(filter));
    },
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    lifecycle({
        componentDidMount() {
            this.props.getFollowers();
        },
    }),
    withHandlers({
        addMember: props => (data, callback) => {
            props.addGymMember(data, callback);
        },
        deleteMember: props => (id, callback) => {
            props.deleteGymMember(id, callback);
        },
    }),
)(AddmemberModal);



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddMemberModal/index.js